import React from "react";
import "./other_solutions_view.css";
import TitlePages from "../../../core/components/title_pages/title_pages.jsx";
import { scrollToSectionUtils } from "../../../core/utils/scroll_to_section_ultils.jsx";
import { FaArrowRight } from "react-icons/fa6";
import { HiLightBulb } from "react-icons/hi2";
import { otherSolutionsMapper } from "../utils/mapper/other_solutions_mapper.jsx";

const OtherSolutionsView = () => {
    const scrollToContact = () => scrollToSectionUtils('contato');
    const { title, sectionTitle, largeCards, mediumCards, smallCards } = otherSolutionsMapper;

    return (
        <div className="outher_soluctions">
            <div className="container">
                <TitlePages title={title} />
                <div className="title">
                    <h1>{sectionTitle.split('\n').map((line, i) => (
                        <React.Fragment key={i}>{line}{i < 1 && <br />}</React.Fragment>
                    ))}</h1>
                </div>
                <div className="row cards_outher_soluctions ">
                    <div className="col-6">
                        {largeCards[0] && (
                            <div className="card_large">
                                <div className="image_card_large">
                                    <img src={largeCards[0].image} alt="" />
                                </div>
                                <div className="content_card_large">
                                    <div className="title_card_large"><h1>{largeCards[0].title}</h1></div>
                                    <div className="description_card_large"><h2>{largeCards[0].description}</h2></div>
                                    {largeCards[0].hasButton && (
                                        <div className="button_card_large" onClick={scrollToContact}>
                                            <p>Entrar em contato</p>
                                            <FaArrowRight />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                        {mediumCards[0] && (
                            <div className="card_medium">
                                <div className="image_card_medium">
                                    <img src={mediumCards[0].image} alt="" />
                                </div>
                                <div className="card_medium_content">
                                    <div className="title_card_medium"><h1>{mediumCards[0].title}</h1></div>
                                    <div className="description_card_medium"><p>{mediumCards[0].description}</p></div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="col-6">
                        <div className="row">
                            {smallCards.map((card) => (
                                <div key={card.id} className="col-6">
                                    <div className="card_small">
                                        <div className="title_card_small">
                                            <HiLightBulb />
                                            <h1>{card.title}</h1>
                                        </div>
                                        <div className="description_card_small"><p>{card.description}</p></div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {largeCards[1] && (
                            <div className="card_large" id={largeCards[1].customId || undefined}>
                                <div className="image_card_large">
                                    <img src={largeCards[1].image} alt="" />
                                </div>
                                <div className="content_card_large" id={largeCards[1].customContentId || undefined}>
                                    <div className="title_card_large"><h1>{largeCards[1].title}</h1></div>
                                    <div className="description_card_large"><h2>{largeCards[1].description}</h2></div>
                                    {largeCards[1].hasButton && (
                                        <div className="button_card_large" onClick={scrollToContact}>
                                            <p>Entrar em contato</p>
                                            <FaArrowRight />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="col-12">
                        {mediumCards[1] && (
                            <div className="card_medium_public_store">
                                <div className="card_medium_content_public_store">
                                    <div className="title_card_medium_public_store"><h1>{mediumCards[1].title}</h1></div>
                                    <div className="description_card_medium_public_store"><p>{mediumCards[1].description}</p></div>
                                </div>
                                <div className="image_card_medium_public_store">
                                    <img src={mediumCards[1].image} alt="" />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OtherSolutionsView;
